<template>
  <oie-base-button
    is-type="a"
    :url="url"
    css-classes="button-link button-link--narrow skip-link"
    :text="proxyText"
    @click="handleClick">
  </oie-base-button>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: '#skipmain'
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    proxyText() {
      return this.text ? this.text : this.tStatic('skipToMainContent')
    }
  },
  methods: {
    handleClick(event) {
      event.preventDefault()
      document.querySelector('#skipmain').focus()
    }
  }

}
</script>

<style lang="scss">
.skip-link {
  position:absolute;
  left:-10000px;
  top:auto;
  width:1px;
  height:1px;
  overflow:hidden;
}

.skip-link:focus {
  position: fixed ;
  top: 1rem ;
  left: 1rem ;
  width: auto ;
  height: 2.5rem ;
  z-index: 999;
}

</style>
